import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      // 仪表板
      path: '/',
      name: 'dashBoard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/dashBoard'], resolve)
    },
    {
      // APP设置
      path: '/appSet',
      name: 'appSet',
      meta: {
        menu: '/appSet',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/appSet'], resolve)
    },
    {
      // APP设置详情
      path: '/appSetDetail',
      name: 'appSetDetail',
      meta: {
        menu: '/appSet'
      },
      component: resolve => require(['@/pages/appSet/detail'], resolve)
    },
    {
      // 模板定义
      path: '/templateSet',
      name: 'templateSet',
      meta: {
        menu: '/templateSet',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/templateSet'], resolve)
    },
    {
      // 新建消息模板
      path: '/addTemplate',
      name: 'addTemplate',
      meta: {
        menu: '/templateSet'
      },
      component: resolve => require(['@/pages/templateSet/add'], resolve)
    },
    {
      // 消息模板详情
      path: '/templateDetail',
      name: 'templateDetail',
      meta: {
        menu: '/templateSet'
      },
      component: resolve => require(['@/pages/templateSet/detail'], resolve)
    },
    {
      // 业务模板
      path: '/business',
      name: 'business',
      meta: {
        menu: '/business',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/business'], resolve)
    },
    {
      // 业务模板详情
      path: '/businessDetail',
      name: 'businessDetail',
      meta: {
        menu: '/business'
      },
      component: resolve => require(['@/pages/business/detail'], resolve)
    },
    {
      // 待审批消息
      path: '/awaitApprove',
      name: 'awaitApprove',
      meta: {
        menu: '/awaitApprove',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/awaitApprove'], resolve)
    },
    {
      // 待审批消息详情
      path: '/approveDetail',
      name: 'approveDetail',
      meta: {
        menu: '/awaitApprove'
      },
      component: resolve => require(['@/pages/awaitApprove/detail'], resolve)
    },
    {
      // 消息列表
      path: '/msgList',
      name: 'msgList',
      meta: {
        menu: '/msgList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/msgList'], resolve)
    },
    {
      // 消息详情
      path: '/msgDetail',
      name: 'msgDetail',
      meta: {
        menu: '/msgList'
      },
      component: resolve => require(['@/pages/msgList/detail'], resolve)
    },
    {
      // 消息权限
      path: '/msgJdn',
      name: 'msgJdn',
      meta: {
        menu: '/msgJdn',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/msgJdn'], resolve)
    },
    {
      // 新增消息权限
      path: '/addMsgJdn',
      name: 'addMsgJdn',
      meta: {
        menu: '/msgJdn'
      },
      component: resolve => require(['@/pages/msgJdn/add'], resolve)
    },
    {
      // 消息权限详情
      path: '/msgJdnDetail',
      name: 'msgJdnDetail',
      meta: {
        menu: '/msgJdn'
      },
      component: resolve => require(['@/pages/msgJdn/detail'], resolve)
    },
    {
      // 新闻公告
      path: '/news',
      name: 'news',
      meta: {
        menu: '/news'
      },
      component: resolve => require(['@/pages/news'], resolve)
    },
    {
      // 新增新闻公告
      path: '/addNews',
      name: 'addNews',
      meta: {
        menu: '/news'
      },
      component: resolve => require(['@/pages/news/add'], resolve)
    },
    {
      // 新闻公告详情
      path: '/newsDetail',
      name: 'newsDetail',
      meta: {
        menu: '/news'
      },
      component: resolve => require(['@/pages/news/detail'], resolve)
    },
    {
      // 消息推送
      path: '/msgSend',
      name: 'msgSend',
      meta: {
        menu: '/msgSend',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/msgSend'], resolve)
    },
    {
      // 新增消息推送
      path: '/addSendMsg',
      name: 'addSendMsg',
      meta: {
        menu: '/msgSend'
      },
      component: resolve => require(['@/pages/msgSend/add'], resolve)
    },
    {
      // 消息推送详情
      path: '/msgSendDetail',
      name: 'msgSendDetail',
      meta: {
        menu: '/msgSend'
      },
      component: resolve => require(['@/pages/msgSend/detail'], resolve)
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js